<div class="slideout-content">
  <!-- Modal to add new user starts-->
  <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
    <div class="modal-dialog" 
    [ngStyle]="
    isSmallDisplay?{'width': '26rem'} : {'width': '60%'}"
    >
      <form class="add-new-user modal-content pt-0" (ngSubmit)="(editLocationForm.form.valid)" #editLocationForm="ngForm">
        <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="toggleSidebar('location-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentLocation.id != null">Edit Location</h5>
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentLocation.id == null">New Location</h5>
        </div>

        <div class="modal-body flex-grow-1">
          
          <div class="row">
            <div class="col-12 mb-1">
              <h5 class="modal-title" id="exampleModalLabel">Location Details</h5>
            </div>
            <div class="col-md-6">
              <!-- NAME -->
              <div class="form-group">
                <label class="form-label" for="location-sidebar-locationName">Location Name</label>
                <input
                  type="text"
                  class="form-control dt-name"
                  id="location-sidebar-locationName"
                  placeholder="Location Name"
                  name="location-sidebar-locationName"
                  [(ngModel)]="currentLocation.locationName"
                  [class.error]="editLocationForm.submitted && FNameRef.invalid"
                  #FNameRef="ngModel"
                  required
                  aria-label="Location Name"
                  aria-describedby="location-sidebar-locationName"
                />
                <span *ngIf="editLocationForm.submitted && FNameRef.invalid" class="invalid-form">
                  <small class="form-text text-danger" *ngIf="FNameRef.errors.required">This field is required!</small>
                </span>
              </div>
              <!-- TIME ZONE -->
              <div class="form-group">
                <label>Time Zone</label>
                <!-- Select Multi with Icon -->
                <ng-select
                  [items]="

                  [
                    {'name':'Australia/ACT','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Adelaide','utc_offset': '+09:30', 'abbreviation': 'ACST'},
                    {'name':'Australia/Brisbane','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Broken_Hill','utc_offset': '+09:30', 'abbreviation': 'ACST'},
                    {'name':'Australia/Canberra','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Currie','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Darwin','utc_offset': '+09:30', 'abbreviation': 'ACST'},
                    {'name':'Australia/Eucla','utc_offset': '+08:45', 'abbreviation': '845'},
                    {'name':'Australia/Hobart','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/LHI','utc_offset': '+10:30', 'abbreviation': '1030'},
                    {'name':'Australia/Lindeman','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Lord_Howe','utc_offset': '+10:30', 'abbreviation': '1030'},
                    {'name':'Australia/Melbourne','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/North','utc_offset': '+09:30', 'abbreviation': 'ACST'},
                    {'name':'Australia/NSW','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Perth','utc_offset': '+08:00', 'abbreviation': 'AWST'},
                    {'name':'Australia/Queensland','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/South','utc_offset': '+09:30', 'abbreviation': 'ACST'},
                    {'name':'Australia/Sydney','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Tasmania','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/Victoria','utc_offset': '+10:00', 'abbreviation': 'AEST'},
                    {'name':'Australia/West','utc_offset': '+08:00', 'abbreviation': 'AWST'},
                    {'name':'Australia/Yancowinna','utc_offset': '+09:30', 'abbreviation': 'ACST'}
                  ]
                  
                  "
                  [multiple]="false"
                  bindLabel="name"
                  bindValue="name"
                  [closeOnSelect]="true"
                  name="locations-timezone"
                  [(ngModel)]="currentLocation.locationTimeZone"
                >
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">
                      {{ item.name }}</span
                    >
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </ng-template>
    
                  <ng-template ng-option-tmp let-item="item">    
                    {{ item.name }}
                  </ng-template>
                </ng-select>
                <!--/ Select Multi with Icon -->
              </div>
              <!-- WEBSITE -->
              <div class="form-group">
                <label class="form-label" for="location-sidebar-website">Website</label>
                <input
                  type="text"
                  class="form-control dt-name"
                  id="location-sidebar-website"
                  placeholder="Location Website"
                  name="location-sidebar-website"
                  [(ngModel)]="currentLocation.locationWebsite"
                  [value]=""
                  [class.error]="editLocationForm.submitted && FLocationWebsiteRef.invalid"
                  #FLocationWebsiteRef="ngModel"
                  required
                  aria-label="Location Website"
                  aria-describedby="location-sidebar-website"
                />
                <span *ngIf="editLocationForm.submitted && FLocationWebsiteRef.invalid" class="invalid-form">
                  <small class="form-text text-danger" *ngIf="FLocationWebsiteRef.errors.required">This field is required!</small>
                </span>
              </div>
              <!-- ADDRESS -->
              <div class="form-group">
                <label class="form-label" for="location-sidebar-address">Address</label>
                <input
                  type="text"
                  id="location-sidebar-address"
                  class="form-control dt-address"
                  placeholder="Location Address"
                  aria-label="Location Address"
                  aria-describedby="location-sidebar-address2"
                  name="user-address"
                  [(ngModel)]="currentLocation.locationAddress"
                  [class.error]="editLocationForm.submitted && FAddressRef.invalid"
                  #FAddressRef="ngModel"
                  required
                />
                <span *ngIf="editLocationForm.submitted && FAddressRef.invalid" class="invalid-form">
                  <small class="form-text text-danger" *ngIf="FAddressRef.errors.required">This field is required!</small>
                </span>
              </div>

            </div>
            <div class="col-md-6">            
              <div *ngIf="currentLocation.locationLogo.length > 0; else customAvatar"
                style="
                  border: 1px solid rgba(34, 41, 47, 0.2);
                  border-radius: 5px;
                  width:100%;
                  height:288px;
                  align-content: center;
                  text-align-last: center;"
                >
                
                <img
                  class="user-avatar users-avatar-shadow rounded mr-2 my-25 cursor-pointer"
                  [src]="currentLocation.locationLogo"
                  width= "150px;"
                  height="150px;"
                  id="locationLogo"
                  alt="Location logo"
                />
                <button type="button"  class="btn btn-icon rounded-circle btn-outline-secondary" 
                      (click)="deleteImage()"
                      style="position: absolute;  
                      right: 20px;
                      top: 5px;"
                      rippleEffect>
                        <span [data-feather]="'trash-2'"></span>
                    </button>
              </div>
       
              <ng-template #customAvatar>
                <div
                  class="mr-0 ml-0 bg-light-secondary"
                  style="
                  border: 1px solid rgba(34, 41, 47, 0.2);
                  border-radius: 5px;
                  width:100%;
                  height:288px;
                  text-align: center;
                  align-content: center;
                  "
                >
                  <button type="button"  class="btn btn-icon rounded-circle btn-outline-secondary" 
                    style="position: absolute;  
                    right: 20px;
                    top: 5px;"
                    (click)="openSender(modalLG)"
                    rippleEffect>
                      <span [data-feather]="'edit'"></span>
                  </button>
                  <span>
                    <i [data-feather]="'image'" [size]="100"></i>
                  </span>
                </div>
              </ng-template>
            </div>
            <!-- locationDocName -->
            <div class="form-group col-6">
                <label class="form-label" for="location-sidebar-locationDocName">Business Name</label>
                <input
                  type="text"
                  class="form-control dt-name"
                  id="location-sidebar-locationDocName"
                  placeholder="Location Business Name"
                  name="location-sidebar-locationDocName"
                  [(ngModel)]="currentLocation.locationDocName"
                  [value]=""
                  [class.error]="editLocationForm.submitted && FNameRef.invalid"
                  #FNameRef="ngModel"
                  required
                  aria-label="Location Business Name"
                  aria-describedby="location-sidebar-locationDocName"
                />
                <span *ngIf="editLocationForm.submitted && FNameRef.invalid" class="invalid-form">
                  <small class="form-text text-danger" *ngIf="FNameRef.errors.required">This field is required!</small>
                </span>
            </div>

            <!-- locationDocId -->
            <div class="form-group col-6">
              <label class="form-label" for="location-sidebar-locationDocId">ABN</label>
              <input
                type="text"
                id="location-sidebar-locationDocId"
                class="form-control dt-phone"
                placeholder="Location DocId"
                aria-label="Location DocId"
                aria-describedby="location-sidebar-locationDocId"
                name="location-docid"
                [(ngModel)]="currentLocation.locationDocId"
                [class.error]="editLocationForm.submitted && FDocIdRef.invalid"
                #FDocIdRef="ngModel"
                required
              />
              <span *ngIf="editLocationForm.submitted && FDocIdRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FDocIdRef.errors.required">This field is required!</small>
              </span>
            </div>

            <!-- locationDocType -->
            <div class="form-group col-12" > 
              <label> Type of legal entity</label>
              <!-- Select Multi with Icon -->
              <ng-select
                [items]="

                [
                  {'name':'individual'},
                  {'name':'organization'},
                  {'name':'soleProprietorship'},
                  {'name':'trust'}
                ]      
                "
                [multiple]="false"
                bindLabel="name"
                bindValue="name"
                [closeOnSelect]="false"
                name="locationLegalType"
                [(ngModel)]="currentLocation.locationLegalType"
              >  
              <ng-template ng-label-tmp let-item="item" let-clear="clear">
                <span class="ng-value-label">
                  {{ item.name }}</span
                >
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">    
                {{ item.name }}
              </ng-template>

              </ng-select>
              <!--/ Select Multi with Icon -->
            </div>

            <!-- locationPhone -->
            <div class="form-group col-6">
              <label class="form-label" for="location-sidebar-phone">Phone</label>
              <input
                type="text"
                id="location-sidebar-phone"
                class="form-control dt-phone"
                placeholder="0000 000 000"
                mask="9000 000 000"
                aria-label="Location Phone"
                aria-describedby="location-sidebar-phone2"
                name="location-phone"
                [(ngModel)]="currentLocation.locationPhone"
                [class.error]="editLocationForm.submitted && FPhoneRef.invalid"
                #FPhoneRef="ngModel"
                required
              />
              <span *ngIf="editLocationForm.submitted && FPhoneRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FPhoneRef.errors.required">This field is required!</small>
              </span>
            </div>

            <!-- locationDocName -->
            <div class="form-group col-6">
              <label class="form-label" for="location-sidebar-email">Email</label>
              <input
                type="text"
                id="location-sidebar-email"
                class="form-control dt-email"
                placeholder="john.doe@example.com"
                aria-label="john.doe@example.com"
                aria-describedby="location-sidebar-email2"
                name="user-email"
                [(ngModel)]="currentLocation.locationEmail"
                [class.error]="editLocationForm.submitted && FEmailRef.invalid"
                #FEmailRef="ngModel"
                required
              />
              <span *ngIf="editLocationForm.submitted && FEmailRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FEmailRef.errors.required">This field is required!</small>
              </span>
            </div>
            <!-- PRACTICE -->
            <div class="form-group col-12" > 
              <label>List Dental Practitioners</label>
              <!-- Select Multi with Icon -->
              <ng-select
                [items]=""
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                disabled
                [closeOnSelect]="false"
                name="usersList"
                [(ngModel)]="currentLocation.userId"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">
                    <img src="../../../../../assets/images/profile/user-uploads/user-00.png" width="20px" height="20px" /> 
                    {{item.firstName}} {{item.lastName}}</span
                  >
                  <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </ng-template>
  
                <ng-template ng-header-tmp>
                  <a
                    (click)="selectAll()"
                    class="btn btn-flat-primary btn-sm"
                  >
                    Select all
                  </a>
                  <a
                    (click)="unselectAll()"
                    class="btn btn-flat-primary btn-sm"
                  >
                    Unselect all
                 </a>
                </ng-template>
  
                <ng-template ng-option-tmp let-item="item">
                  <img src="../../../../../assets/images/profile/user-uploads/user-00.png" width="20px" height="20px" /> 
  
                  {{item.firstName}} {{item.lastName}}
                </ng-template>
              </ng-select>
              <!--/ Select Multi with Icon -->
            </div>

            <div class="col-12 mb-1">
              <h5 class="modal-title" id="exampleModalLabel">Profile Description</h5>
              <span><small>The information you enter here will be displayed on your SmilePass profile</small></span>
            </div>
            <div class="form-group col-12">

              <label>Practice tag line</label>
              <input
                type="text"
                class="form-control dt-name"
                id="location-sidebar-locationPracticeTagLine"
                placeholder=""
                name="location-sidebar-locationPracticeTagLine"
                [(ngModel)]="currentLocation.locationPracticeTagLine"
                [value]=""
                [class.error]="editLocationForm.submitted && FNameRef.invalid"
                #FNameRef="ngModel"
                required
                aria-label="Location Tag Line"
                aria-describedby="location-sidebar-locationPracticeTagLine"
              />
              <small class="form-text text-muted"> One line to make your practice stand out. </small>

              <span *ngIf="editLocationForm.submitted && FNameRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="FNameRef.errors.required">This field is required!</small>
              </span>
            </div>
            <div class="form-group col-12">
              <label>Practice description</label>
              <fieldset class="form-label-group mb-0">
                <textarea
                  [(ngModel)]="currentLocation.locationPracticeDescription"
                  name="location-sidebar-locationPracticeDescription"
                  #textLength
                  [maxlength]="1000"
                  class="form-control char-textarea"
                  id="location-sidebar-locationPracticeDescription"
                  rows="3"
                  placeholder=""
                ></textarea>
              </fieldset>
              <small class="textarea-counter-value float-right"
                ><span *ngIf="textLength" class="char-count">{{ textLength.value.length }}</span>
                <span *ngIf="!textLength" class="char-count">0 </span> / 1000
              </small>
              <small class="form-text text-muted"> Let patients know about your services and what sets your practice apart. </small>

            </div>
            <div class="col-12 mb-1">
              <h5 class="modal-title" id="exampleModalLabel">Account Status</h5>
              <span *ngIf="currentLocation.locationStatus == 'pending' && currentLocation.merchantAccount == ''"
              ><small>Fill in all the fields of the form correctly to start the activation.</small></span>
              <span *ngIf="currentLocation.locationStatus == 'pending' && currentLocation.merchantAccount != ''"
              ><small>To enable secure and efficient payment processing, please activate your account and specify your clinic's location. This one-time setup allows patients to make direct payments to your practice's bank account.</small></span>
            </div>

            <div class="col-6 mb-1">
              <span
                class="badge badge-pill  mr-1"
                [ngClass]="{
                  'badge-light-success': currentLocation.locationStatus == 'active',
                  'badge-light-secondary': currentLocation.locationStatus == 'inactive',
                  'badge-light-warning': currentLocation.locationStatus == 'pending'
                }"
              >{{currentLocation.locationStatus.toUpperCase()}}</span>
  
            </div>
            <div class="col-6 mb-1" style="align-content: center;">
              <button
              class="btn btn-outline-secondary"
              (click)="activateLocation(currentLocation.id)"
              rippleEffect
              *ngIf="currentLocation.locationStatus == 'pending' && currentLocation.merchantAccount != ''"
              >
              Link to activate
              </button>
            </div>
          </div>
        </div>      
        <div class="modal-footer">
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-primary mr-1" *ngIf="currentLocation.id == null" (click)="submit(editLocationForm, 'new')" rippleEffect>Submit</button>
            <button type="submit" class="btn btn-primary mr-1" *ngIf="currentLocation.id != null" (click)="submit(editLocationForm, 'update')" rippleEffect>Save Changes</button>
            <button
              type="reset"
              class="btn btn-outline-secondary"
              (click)="toggleSidebar('location-sidebar')"
              rippleEffect
              >
              Cancel
            </button>

          </div>
        </div>      
      </form>
    </div>
  </div>
  <!-- Modal to add new user Ends-->
</div>


  <!-- Modal -->
  <ng-template #modalLG let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel1">Select Logo</h4>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body row" tabindex="0" ngbAutofocus style="height: 400px; overflow-y: auto;">
      <!-- Select Location -->
      <div class="form-group col-md-8 align-items-center" style="text-align: -webkit-center;">
        <div *ngIf="currentLocation.locationLogo.length == 0;"
          class="mr-0 ml-0 bg-light-secondary"
          style="
          border: 1px solid rgba(34, 41, 47, 0.2);
          border-radius: 5px;
          width:100%;
          text-align: center;
          align-content: center;
          "
        >
          <button type="button"  class="btn btn-icon rounded-circle btn-outline-secondary" 
            onclick="document.getElementById('change-picture').click();"
            style="position: absolute;  
            right: 20px;
            top: 5px;"
            rippleEffect>
              <span [data-feather]="'upload'"></span>
          </button>
          <input
          class="form-control"
          type="file"
          id="change-picture"
          hidden
          accept="image/png, image/jpeg, image/jpg"
          (change)="fileChangeEvent($event)"
          />
          <span>
            <i [data-feather]="'image'" [size]="50"></i>
            Edit your image:
          </span>
          <image-cropper
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [resizeToWidth]="150"
              [aspectRatio]="2 / 2"
              format="png"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded($event)"
              (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()"
              style="height: 300px; border-radius: 5px;
              
" 

          ></image-cropper>
        </div>
          
        

      </div>
      <div class="form-group col-md-4 align-items-center" style="text-align: -webkit-center;
          width:100%;
          text-align: center;
          align-content:center;
          ">
        <span>Final logo:</span>
        <br>
        <img [src]="croppedImage" 
        style="
          border-radius: 5px;
          border: 1px solid rgba(34, 41, 47, 0.2);

        "
        />

      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.close('Select')" (click)="selectCroppedImage()" tabindex="8" rippleEffect>
        Select
      </button>
    </div>
  </ng-template>
  <!-- / Modal -->
